<template>
  <v-main>

  </v-main>
</template>

<script>
export default {
  name: 'RetourHome',
  data() {
    return {}
  },
  methods: {},
  mounted() {
    console.log("test")
    this.$router.push("/retoure")
  }
}
</script>

<style scoped>

</style>
